import type { NavLink } from './types'

/**
 * Primer elemento del menú, antes de las categorías (móvil y escritorio):
 * vuelta a la home desde cualquier página.
 */
export const NAV_HOME_LINK: NavLink = { id: 'home', label: 'Home', href: '/' }

/**
 * Enlaces de sección del menú (no son categorías del backend, son rutas fijas
 * de la web/app). Se muestran tras las categorías del `menu`.
 */
export const NAV_LINKS: NavLink[] = [
  { id: 'agenda', label: 'Agenda', href: '/agenda' },
  { id: 'artistas', label: 'Artistas', href: '/artistas' },
  { id: 'recintos', label: 'Recintos', href: '/recintos' },
  { id: 'promociones', label: 'Promociones', href: '/promociones' },
  { id: 'postsale', label: 'Consulta tus entradas', href: '/postsale' },
  { id: 'blog', label: 'Blog', href: '/blog' },
  { id: 'faqs', label: 'Ayuda', href: '/faqs' },
]

/**
 * Analítica (`components-fingerprint/Menú categorías.csv`, ficha de
 * navegación por categorías; mismo `click_subtype`/`module_name` que `Explora`).
 * `click_type` = `menu` por decisión de Analítica para el NavDrawer (el CSV
 * muestra `card` solo para los iconos de `Explora`; el diccionario admite
 * `menu`).
 */
export const NAV_DRAWER_ANALYTICS_CLICK_TYPE = 'menu'
export const NAV_DRAWER_ANALYTICS_CLICK_SUBTYPE = 'category_nav'
export const NAV_DRAWER_ANALYTICS_MODULE_NAME = 'category_nav_menu'

/**
 * Separador de `nav_path` entre niveles (p. ej. `conciertos/pop`). El
 * diccionario solo fija "minúsculas, sin tildes, guiones bajos" y no define
 * separador: ⚠️ PROVISIONAL, pendiente de confirmar con Analítica.
 */
export const NAV_PATH_SEPARATOR = '/'
